import { render, staticRenderFns } from "./AlertPanel.vue?vue&type=template&id=57a58bb2&scoped=true"
import script from "./AlertPanel.vue?vue&type=script&lang=ts"
export * from "./AlertPanel.vue?vue&type=script&lang=ts"
import style0 from "./AlertPanel.vue?vue&type=style&index=0&id=57a58bb2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a58bb2",
  null
  
)

export default component.exports